import styled from 'styled-components'

type RankCellProps = {
  rank: number
}
export const HolderTableRankCell = (props: RankCellProps) => {
  return (
    <Root>
      <Text>{props.rank}</Text>
    </Root>
  )
}

const Root = styled.div`
  overflow: hidden;
`
const Text = styled.div`
  color: var(--text-11);

  overflow: hidden;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`
